/*                                                                  */

/*                                                  */
interface CinemaClient {
    getHtml(url: string): Promise<string>;
}

export type { CinemaClient };

export class BenefitCinemaStore {
    #html = $state<string | null>(null);
    #client: CinemaClient;
    #inflight: Promise<void> | null = null;
    #inflightDreson: string | null = null;
    #requestId = 0;

    constructor(client: CinemaClient) {
        this.#client = client;
    }

    /*                                                                 */
    get html(): string | null {
        return this.#html;
    }

    /**
 *
 *
 */
    initFromServer(html: string): void {
        if (this.#html !== null) return;
        this.#html = html;
    }

    /**
 *
 *
 *
 */
    fetch(dreson: string): Promise<void> {
        if (this.#inflight && this.#inflightDreson === dreson) return this.#inflight;

        const myId = ++this.#requestId;
        this.#inflightDreson = dreson;
        const url = `/benefit-cinema/cinema/productlist?dreson=${encodeURIComponent(dreson)}`;
        this.#inflight = this.#client
            .getHtml(url)
            .then((html) => {
                if (myId !== this.#requestId) return;
                this.#html = html;
            })
            .finally(() => {
                if (myId === this.#requestId) {
                    this.#inflight = null;
                    this.#inflightDreson = null;
                }
            });
        return this.#inflight;
    }
}

export const BENEFIT_CINEMA_CONTEXT = Symbol('BenefitCinema');
